/**
 * Build router targets for nav items (homepage sections vs app routes vs external URLs).
 */

export function homeSectionPath(sectionId) {
  return { pathname: '/', hash: `#${sectionId}` };
}

export function isHomeSectionTarget(target) {
  return Boolean(target?.sectionId);
}

export function isExternalTarget(target) {
  return Boolean(target?.external && target?.href);
}

export function isAppRouteTarget(target) {
  return Boolean(target?.path);
}

export function resolveNavTarget(target) {
  if (!target) return '/';
  if (isExternalTarget(target)) return target.href;
  if (isAppRouteTarget(target)) return target.path;
  if (isHomeSectionTarget(target)) return homeSectionPath(target.sectionId);
  return '/';
}
